import sixthTape from "../../../../src/audio/the_sixth_tape.mp3";
import * as React from 'react';
export default {
  sixthTape,
  React
};